import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "../UI";
import styled, { useTheme } from "styled-components";
import { Item, renderKeyValue } from "./Common";
import ArrowDownImg from "../asserts/img/arrow_down_white.svg";
import ArrowUpImg from "../asserts/img/arrow_up_white.svg";
import CalenderImg from "../asserts/img/calender_white.svg";

const Line = styled.div(({ color }) => ({
  height: 1,
  width: "100%",
  backgroundColor: color || "#2566CD",
}));

const WorkHoursClac = ({ data, keys, handelWorkHoursCalc }) => {
  const theme = useTheme();

  const [expand, setExpand] = useState(false);
  const { t } = useTranslation("month_reports");

  return (
    <div
      style={{
        borderRadius: `10px 10px 0px 0px`,
        backgroundColor: theme.color.blue,
        position: "fixed",
        bottom: 0,
        width: "100%",
        flex: 1,
        zIndex: 1000,
      }}>
      <div
        style={{
          display: "flex",
          padding: 10,
          justifyContent: "space-between",
          flexDirection: "row",
        }}>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <img
            src={CalenderImg}
            alt="calender"
            style={{ width: 20, height: 20 }}
          />
          <Text
            style={{
              color: theme.color.white,
              fontSize: 16,
              fontWigth: 500,
            }}>
            {t("work_hours")}
          </Text>
        </div>
        <div>
          <img
            src={!!expand ? ArrowDownImg : ArrowUpImg}
            alt={"expand"}
            onClick={() => setExpand(!expand)}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
      {expand && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: 25,
            paddingTop: 0,
            paddingBottom: 10,
            width: "100%",
            gap: 10,
          }}>
          {keys.map((key) => (
            <Item
              labelColor="#A4C7FF"
              valueColor="#FFFFFF"
              label={t(key.key)}
              value={renderKeyValue(key, data)}
              width={"45%"}
            />
          ))}
          <Line />
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <Text
              style={{
                color: theme.color.white,
                fontSize: 16,
                fontWigth: 500,
                width: "50%",
                textAlign: "start",
              }}>
              {t("TOTAL")}
            </Text>
            <Text
              style={{
                color: theme.color.white,
                fontSize: 16,
                fontWigth: 500,
                width: "50%",
                textAlign: "start",
              }}>
              {data.TOTAL}
            </Text>
          </div>
          <div
            onClick={handelWorkHoursCalc}
            style={{
              display: "flex",
              marginTop: 10,
              width: "100%",
              padding: `10px 24px`,
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              borderRadius: 10,
              border: `2px solid #FFF`,
              cursor: "pointer",
            }}>
            <Text
              style={{
                color: theme.color.white,
                fontSize: 16,
                fontWigth: 500,
                textAlign: "center",
              }}>
              {t("work_hours_calc")}
            </Text>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkHoursClac;
